var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSupport(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("path", {
    id: "_Icon_\\u0421olor",
    "data-name": "\\uD83C\\uDFA8 Icon \\u0421olor",
    d: "M10,20A10,10,0,1,1,20,10,10.011,10.011,0,0,1,10,20ZM10,2a8,8,0,1,0,8,8A8.009,8.009,0,0,0,10,2Zm0,14a1,1,0,1,1,1-1A1,1,0,0,1,10,16Zm0-3a1,1,0,0,1-1-1V10a1,1,0,0,1,1-1A1.5,1.5,0,1,0,8.5,7.5a1,1,0,0,1-2,0A3.5,3.5,0,1,1,11,10.837V12A1,1,0,0,1,10,13Z",
    transform: "translate(2 2)",
    fill: "#505358"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-Support"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Support",
    clipPath: "url(#clip-Support)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "question-mark-circle",
    transform: "translate(2 2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "_Icon_\\u0421olor-2",
    "data-name": "\\uD83C\\uDFA8 Icon \\u0421olor",
    d: "M10,20A10,10,0,1,1,20,10,10.011,10.011,0,0,1,10,20ZM10,2a8,8,0,1,0,8,8A8.009,8.009,0,0,0,10,2Zm0,14a1,1,0,1,1,1-1A1,1,0,0,1,10,16Zm0-3a1,1,0,0,1-1-1V10a1,1,0,0,1,1-1A1.5,1.5,0,1,0,8.5,7.5a1,1,0,0,1-2,0A3.5,3.5,0,1,1,11,10.837V12A1,1,0,0,1,10,13Z",
    transform: "translate(0 0)",
    fill: "#505358"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSupport);
export default __webpack_public_path__ + "static/media/Support.dfb96def5568bdbe631a4f9274ce640e.svg";
export { ForwardRef as ReactComponent };